import { PropsWithChildren, RefObject } from 'react';

import { PropsWithId } from '~types/Props.types';

export enum SectionMods {
  Bottom = 'bottom',
  Top = 'top',
  SeparatorS = 'separatorS',
  SeparatorM = 'separatorM',
  SeparatorL = 'separatorL',
}

export type SectionProps = PropsWithChildren<
  PropsWithId<{
    className?: string;
    hash?: string;
    mods?: SectionMods[];
    ref?: RefObject<HTMLDivElement>;
  }>
>;
